import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { take, skipWhile, tap, map } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';
import { Role, userType } from '../models/role';

@Injectable({ providedIn: 'root' })
export class UserRoleGuard implements CanActivate {
  /**
   * @ignore
   */
  constructor(private authService: AuthService, private router: Router) {}

  /**
   * Checks if route is restricted by user role
   * if route role and user role are the same, user can access
   * if no, user is redirected to appropriate route
   * @param route
   * @param state
   * @returns
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // const currentUser = this.authService.currentUserValue;

    return this.authService.LoggedinUser.pipe(
      skipWhile((value) => value === null),
      take(1),
      map((currentUser) => {
        console.log(currentUser)
        if (currentUser) {
          // check if route is restricted by role and type
          if (
            route.data.roles &&
            route.data.roles.indexOf(currentUser.role.name) === -1
          ) {
            // role not authorised so redirect to home page
            if (currentUser.role.name === Role.USER) {
              this.router.navigate(['/']);
            }
            if (currentUser.role.name === Role.WORKER) {
              this.router.navigate(['/worker']);
            }
            if (currentUser.role.name === Role.ROOT) {
              this.router.navigate(['/root']);
            }
            if (currentUser.role.name === Role.FILIALADMIN) {
              this.router.navigate(['/admin']);
            }
            console.log('ne mozeeee');
            return false;
          }
          console.log('|mozeeeeeee');
          // authorised so return true
          return true;
        } else {
          // not logged in so redirect to login page with the return url
          this.router.navigate(['/login'], {
            queryParams: { returnUrl: state.url },
          });
          return false;
        }
      })
    );
  }
}
